export const CHART_CANVAS_WIDTH = 605;
